import { createHttpClient } from '@adapters/HttpClient';
import { ProfitabilityApiAdapter } from '../adapters/ProfitabilityApiAdapter';
import type { ProfitabilitySummaryOrdersQuery, ProfitabilitySummaryOrdersResponse } from '../models/Profitability';
import { apiClientWH } from '@shared/services';
import { useQuery } from '@tanstack/react-query';

const httpClient = createHttpClient(apiClientWH);
const adapter = new ProfitabilityApiAdapter(httpClient);

const DEFAULT_PER_PAGE = 15;

export const useProfitabilitySummaryOrders = (query: ProfitabilitySummaryOrdersQuery | undefined, enabled = true) => {
  const page = query?.page ?? 1;
  const perPage = query?.per_page ?? DEFAULT_PER_PAGE;

  return useQuery<ProfitabilitySummaryOrdersResponse, Error>({
    queryKey: [
      'profitability',
      'summary',
      'orders',
      query?.start_date,
      query?.end_date,
      query?.date_column,
      query?.shop_id,
      query?.payment_method_id,
      query?.shipment_status_id,
      page,
      perPage,
    ],
    queryFn: () =>
      adapter.getSummaryOrders({
        ...query,
        page,
        per_page: perPage,
      }),
    enabled: enabled && !!query?.start_date && !!query?.end_date,
    staleTime: 60 * 1000,
  });
};
